
import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'image-to-right',
  templateUrl: './image-to-right.component.html',
  styleUrls: ['./image-to-right.component.scss']
})
export class ImageToRightComponent {
  @Input() imgURL:string;
  @Input() content:TemplateRef<any>;
  @Input() bgColor:string;
  @Input() topLogo:boolean=true;
  @Input() bottomLogo:boolean=true;
  public environment = environment;
  constructor() { }

}
